<template>
  <span
    class="leaderboard-visibility-toggle hover-item"
    :class="{
      'active': isLeaderboardVisible,
      'light': !isTextColourLight
    }"
    v-tooltip="tooltipContent"
    name="leaderboard-popup-toggle"
    v-aha-click="toggleLeaderboardVisibility"
  >
    <aha-icon
      name="trophy-outlined"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    ></aha-icon>
  </span>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import { LEADERBOARD_TRIGGERS } from '@/constant/leaderboard.constant.js'
import EventBus from '@/eventBus'

const TOGGLE_LEADERBOARD_POPUP_KEYS = [
  'KeyL',
]
const CLOSE_LEADERBOARD_KEYS = [
  'Escape',
  'ArrowRight',
  'ArrowLeft',
]

export default {
  computed: {
    ...mapGetters('leaderboard', ['isLeaderboardVisible']),
    ...mapGetters(['isPresentingOrBackstage', 'isTextColourLight']),
    ...mapState({
      presentation: (state) => state.presentation,
    }),
    tooltipContent() {
      return {
        content: this.$i18nPresenter.t('Leaderboard (L)'),
      }
    },
  },
  mounted() {
    this.registerHotkey()
  },
  destroyed() {
    this.unregisterHotkey()
  },
  methods: {
    ...mapActions('leaderboard', [
      'toggleLeaderboardVisibilityAction',
    ]),
    registerHotkey() {
      EventBus.$on('onKeyboard', this.handleHotkey)
    },
    unregisterHotkey() {
      EventBus.$off('onKeyboard', this.handleHotkey)
    },
    handleHotkey(e) {
      if (!this.isPresentingOrBackstage) return
      if (TOGGLE_LEADERBOARD_POPUP_KEYS.includes(e.code)) {
        this.toggleLeaderboardVisibility(!this.isLeaderboardVisible)
      } else if (CLOSE_LEADERBOARD_KEYS.includes(e.code)) {
        this.toggleLeaderboardVisibility(false)
      }
    },

    toggleLeaderboardVisibility(isVisible) {
      this.toggleLeaderboardVisibilityAction({
        trigger: LEADERBOARD_TRIGGERS.ON_DEMAND_WHILE_PRESENTING,
        isVisible,
        presentation: this.presentation,
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.leaderboard-visibility-toggle {
    display: inline-flex;
    flex-direction: column;
    align-items: center;
    margin-left: 20px;
    cursor: pointer;
    position: relative;
    &:hover::after{
      opacity: 1;
      background: #ebebeb;
    }
    &::after {
      left: -6px;
      top: -6px;
    }

    &.active::after {
      opacity: 1;
      background: #0a0a0a1a;
      &.light {
        background: rgba(255, 255, 255, 0.2);
      }

    }
}
</style>
